export default __webpack_public_path__ + "static/media/icaew_background_xl2.cba16c7f.jpg";